export default __webpack_public_path__ + "36c8e3b8d55a3feb94245e4e08e99728.png";